import Script from 'next/script'
import { actionTracking } from 'utils/posthog'

const Zendesk = () => {
  if (process.env.NEXT_PUBLIC_DISABLE_ZENDESK === 'true') {
    return null
  }

  return (
    <Script
      id='ze-snippet'
      strategy='lazyOnload'
      // eslint-disable-next-line alternative/no-invalid-env-usage
      src={`https://static.zdassets.com/ekr/snippet.js?key=${process.env.NEXT_PUBLIC_ZENDESK_KEY}`}
      onLoad={() => {
        const zE = (
          window as unknown as {
            zE?: (a: string, b: string, c: () => void) => void
          }
        ).zE
        zE?.('webWidget:on', 'open', () => {
          try {
            actionTracking({ action: 'zendesk_support_chat_opened' })
          } catch {
            // never block the chat from opening on analytics failure
          }
        })
      }}
    />
  )
}
export default Zendesk
